export const PUBLIC_ROUTES = {
    Home: "/",
    LibroDeQuejas:"libro-quejas",
    TerminosYCondiciones:"terminos-y-condiciones",
    PoliticasDeProteccion: "politicas-de-proteccion",
    GraciasLibroQuejas:"gracias-libro-quejas"
}
